/**
 * bakeSettingsStore — open/closed state + bake parameters for the Bake Lighting
 * settings panel (ENG-561). Module singleton + subscribe, shared between the DOM
 * panel and the in-Canvas preview gizmos so both react to the same params.
 */
let state = {
  open: false,
  assetId: null,
  params: {
    lpSpacing: 1.5,   // light-probe grid spacing (m)
    lpLayers: 2,      // light-probe horizontal layers
    reflSpacing: 3,   // reflection-capture spacing (m)
    reflInset: 1,     // reflection-capture inset from bounds (m)
  },
  // Preview gizmo visibility toggles (view-only; not sent to the bake).
  show: {
    lightProbes: true,
    reflections: true,
  },
}
const listeners = new Set()
function emit() {
  if (typeof window !== 'undefined') window.__BAKE_SETTINGS__ = state
  for (const fn of listeners) fn()
}

export const bakeSettingsStore = {
  getState() { return state },
  subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn) },
  open(assetId) { state = { ...state, open: true, assetId }; emit() },
  close() { state = { ...state, open: false }; emit() },
  setParams(patch) { state = { ...state, params: { ...state.params, ...patch } }; emit() },
  setShow(patch) { state = { ...state, show: { ...state.show, ...patch } }; emit() },
}
